import { render, staticRenderFns } from "./UnManualClassificationSystem.vue?vue&type=template&id=93892a92&"
import script from "./UnManualClassificationSystem.vue?vue&type=script&lang=js&"
export * from "./UnManualClassificationSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports